import { StatusConfig, StatusState } from '@gripp/shared-logic';
import { FC } from 'react';
import { SubHeaderText } from '../../asset/subHeaderText';
import { RoutineHeaderProps } from '../types';
import { OpenEndedResponse } from './types';

type StatusHeaderProps = RoutineHeaderProps<StatusConfig, StatusState>;

export const StatusHeader: FC<StatusHeaderProps> = (
  props: StatusHeaderProps
) => {
  const { config, currentState } = props;

  const subHeaderText =
    currentState?.state.status === OpenEndedResponse
      ? currentState?.state.openEndedResponse
      : currentState?.state.status;

  return <SubHeaderText>{subHeaderText}</SubHeaderText>;
};
